import { gql } from '@apollo/client';

export const SUYP_GET_REFEREE_CHECK = gql`
  query SUYPGetRefereeCheck($taskId: String!, $profileId: String!) {
    vm {
      task(taskId: $taskId) {
        taskId
        title
        description
        isRefereeCheckTask
        refereeChecksRequired
      }
      refereeCheck(profileId: $profileId, taskId: $taskId) {
        completedTaskRefereeContactId
        refereeOrder
        refereeName
        refereeEmail
        refereePhone
        submissionToken
        dateContactProvided
        dateInvited
        dateLastReminded
        dateSubmitted
        isCompleted
        refereeMessage
        submissionData
      }
    }
  }
`;